import React, {PureComponent} from "react"
import * as PropTypes from "prop-types"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {RouterLink as RouterLinkBase} from "@irati/ui/src/Link"
import authentication from "@irati/auth"

interface Props {
  id: string,
  onClick: () => void,
  text: string,
  to: string,
  tenantName?: string
}

const RouterLink = styled(RouterLinkBase)`
  height: auto !important;
`

class WalletLink extends PureComponent<Props> {
  static defaultProps = {
    wallet: {
      availableBalance: 0,
      currency: authentication.defaultUserCurrency()
    }
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired,
    apps: PropTypes.object.isRequired
  }

  render() {
    const {id, onClick, text, to, tenantName} = this.props
    const {WALLET} = this.context.apps

    return (
      <RouterLink app={WALLET} id={id} onClick={onClick} to={to} plain>
        {tenantName ? <FormattedMessage id={text} values={{tenantName}} /> : <FormattedMessage id={text} />}
      </RouterLink>
    )
  }
}

export default WalletLink
